export default {"src":"/_next/static/media/mondial-logo-white-rgb.19b2d5f4.svg","height":575,"width":550,"blurWidth":0,"blurHeight":0};